"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetTradePwdWithDynCode = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var ResetTradePwdWithDynCode = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ResetTradePwdWithDynCode, _super);
    function ResetTradePwdWithDynCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '客户设置交易密码';
        _this.code = '101025';
        _this.desc = '客户设置交易密码';
        _this.requestParams = new password_1.ResetTradePwdWithDynCodeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ResetTradePwdWithDynCode;
}(service_1.BaseService));
exports.ResetTradePwdWithDynCode = ResetTradePwdWithDynCode;
//# sourceMappingURL=resetTradePwdWithDynCode.js.map